import React from "react";
import { COMPANY } from "@/lib/api";

// Local, optimized copy of the official logo (same 150x150 artwork, WebP 7 KB).
// Served from bagnoman.it itself: no third-party host in the critical path.
const LOGO_URL = "/images/optimized/logo-150.webp";

export function BagnomanLogo({ size = 40, withText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src={LOGO_URL}
        alt="Bagnoman \u2014 All Service Toscana"
        width={size}
        height={size}
        className="rounded-lg object-cover shrink-0"
        loading="eager"
        decoding="async"
        style={{ width: size, height: size }}
      />
      {withText && (
        <div className="leading-tight">
          <div className="text-[15px] font-bold text-[hsl(var(--brand-navy))] tracking-tight">BAGNOMAN</div>
          <div className="text-[10px] uppercase tracking-wider text-[hsl(var(--muted-foreground))] font-semibold">All Service Toscana</div>
        </div>
      )}
    </div>
  );
}

export { LOGO_URL };
export default BagnomanLogo;
